import { useTitle } from "../../hooks/useTitle"


export const AboutMe = ({title}) => {
    useTitle(title);
  return (
    <div>AboutMe</div>
  )
}
